import { compose, lifecycle, withState } from "recompose";
import { computeDistanceBetween } from "app/helpers/geoHelper";
import ClubList from "./ClubList";
import Immutable from "immutable";

const getDistance = (currentPosition, x, y) => computeDistanceBetween(currentPosition.lat, currentPosition.lon, x, y);

function componentWillMount() {
  const { clubs, setOrderedClubs } = this.props;
  setOrderedClubs(clubs);
}

function componentWillReceiveProps(nextProps) {
  const { currentPosition } = nextProps;
  const { orderedClubs, setOrderedClubs } = this.props;

  if (currentPosition && currentPosition !== this.props.currentPosition) {
    const sortOrderedClubs = orderedClubs.sort((clubA, clubB) => {
      const distA = getDistance(currentPosition, clubA.get("x"), clubA.get("y"));
      const distB = getDistance(currentPosition, clubB.get("x"), clubB.get("y"));
      return distA - distB;
    });
    setOrderedClubs(sortOrderedClubs);
  }
}

export default compose(
  withState("orderedClubs", "setOrderedClubs", Immutable.List()),
  lifecycle({ componentWillMount, componentWillReceiveProps })
)(ClubList);



// WEBPACK FOOTER //
// ./src/app/components/ClubList/ClubListContainer.js